import React from 'react';
export default function Code(props) {
    return React.createElement("span", { className: "code" }, props.children);
}
//# sourceMappingURL=code.js.map